export const assetKeyToTitleMapper = {
  "retail/commercial": "Retail/Commercial",
  specialty: "Specialty",
  "residential multi-family": "Multi Family",
  land: "Land",
  industrial: "Industrial",
  office: "Office",
  hospitality: "Hospitality",
};
export const mockedItems = {
  sections: [
    {
      id: 0,
      categoryList: [
        {
          name: "Retail/Commercial",
          key: "retail/commercial",
          itemList: [
            {
              id: 0,
              key: "strip mall",
              title: "Strip Mall",
            },
            {
              id: 1,
              key: "commercial mall",
              title: "Commercial Mall",
            },
            {
              id: 2,
              key: "commercial bay",
              title: "Commercial Bay",
            },
            {
              id: 3,
              key: "other",
              title: "Other",
            },
          ],
        },
        {
          name: "Specialty",
          key: "specialty",
          itemList: [
            {
              id: 0,
              key: "student housing",
              title: "Student Housing",
            },
            {
              id: 1,
              key: "retirement facility",
              title: "Retirement Facility",
            },
            {
              id: 2,
              key: "storage",
              title: "Storage",
            },
            {
              id: 3,
              key: "other",
              title: "Other",
            },
          ],
        },
      ],
    },
    {
      id: 1,
      categoryList: [
        {
          name: "Multi Family",
          key: "residential multi-family",
          itemList: [
            {
              id: 0,
              key: "condominium/apartment",
              title: "Condominium / Apartment",
            },
            {
              id: 1,
              key: "row/townhouse",
              title: "Row / Townhouse",
            },
            {
              id: 2,
              key: "other",
              title: "Other",
            },
          ],
        },
        {
          name: "Land",
          key: "land",
          itemList: [
            {
              id: 0,
              key: "serviced land",
              title: "Serviced",
            },
            {
              id: 1,
              key: "raw land",
              title: "Raw",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      categoryList: [
        {
          name: "Industrial",
          key: "industrial",
          itemList: [
            {
              id: 0,
              key: "warehouse",
              title: "Warehouse",
            },
            {
              id: 1,
              key: "industrial bay",
              title: "Industrial Bay",
            },
            {
              id: 2,
              key: "other",
              title: "Other",
            },
          ],
        },
        {
          name: "Office",
          key: "office",
          itemList: [
            {
              id: 0,
              key: "office",
              title: "Office",
            },
          ],
        },
      ],
    },
    {
      id: 3,
      categoryList: [
        {
          name: "Hospitality",
          key: "hospitality",
          itemList: [
            {
              id: 0,
              key: "hotel",
              title: "Hotel",
            },
            {
              id: 1,
              key: "resort",
              title: "Resort",
            },
            {
              id: 2,
              key: "other",
              title: "Other",
            },
          ],
        },
      ],
    },
  ],
};
